import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Scale, ArrowLeft, ExternalLink } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import SEOHead from './SEOHead';

interface ServiceUnavailableProps {
  serviceName: string;
}

export const ServiceUnavailable: React.FC<ServiceUnavailableProps> = ({ serviceName }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col ds-public-page">
      <SEOHead
        title={`${serviceName} | LegeaAplicata`}
        description="Asistență juridică de specialitate."
        noIndex={true}
      />
      <Header />
      <main className="flex-grow flex items-center justify-center py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-lg w-full bg-surface rounded-ds-card border border-border shadow-[0_20px_50px_rgba(30,30,60,0.05)] p-8 sm:p-10 text-center relative overflow-hidden group">
          {/* Top subtle decorative pattern */}
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-purple-500 via-[#6D4CFF] to-blue-500"></div>

          <div className="w-16 h-16 rounded-ds-card bg-ai/10 text-[#6D4CFF] flex items-center justify-center mx-auto mb-6 transition-transform duration-500 group-hover:scale-110">
            <Scale className="w-8 h-8" />
          </div>

          <h1 className="text-2xl sm:text-3xl font-serif font-black text-content mb-4 tracking-tight">
            Asistență Juridică Specializată
          </h1>

          <p className="text-content-muted text-sm sm:text-base leading-relaxed mb-8">
            Pentru servicii de <strong>{serviceName}</strong> sau alte solicitări juridice, vă recomandăm să alegeți un avocat autorizat direct din <strong>Tabloul Avocaților din România</strong>.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full">
            <a
              href="https://www.ifep.ro/Justice/Lawyers/LawyersPanel.aspx"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#6D4CFF] hover:bg-[#5b3ce0] text-white font-bold rounded-xl shadow-raised shadow-purple-100 hover:shadow-raised hover:shadow-purple-200 transition-all duration-300 transform hover:-translate-y-0.5"
            >
              <span>Tabloul Avocaților</span>
              <ExternalLink className="w-4 h-4" />
            </a>

            <button
              onClick={() => navigate('/cautare')}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-surface hover:bg-background text-content-secondary hover:text-content font-bold rounded-xl border border-border transition-all duration-300 transform hover:-translate-y-0.5"
            >
              <ArrowLeft className="w-4 h-4" />
              <span>Înapoi la Căutare</span>
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
export default ServiceUnavailable;
